const { REACT_APP_BASE_URL, REACT_APP_INSIGHTS_URL, REACT_APP_API_URL } = process.env

export const NAMESPACE = 'reportingApi'

const reportingAPIEndpointV1 = `${REACT_APP_BASE_URL}/reporting/v1`
const reportingAPIEndpointV2 = `${REACT_APP_INSIGHTS_URL}/reports`

export const ENDPOINTS = {
  BASE: reportingAPIEndpointV1,
  ACCOUNTS_RECEIVABLE: `${reportingAPIEndpointV2}/accounts-receivable-v2`,
  COMMISSION_SPLIT: `${REACT_APP_API_URL}/accounting/commission/report`,
  AGENCY_COMMISSION: `${reportingAPIEndpointV2}/agency-commission`,
  RENT_ROLL: `${reportingAPIEndpointV2}/rent-roll-v2`,
  CASH_FLOW: `${reportingAPIEndpointV2}/cash-flow`,
  DEPOSITS: `${reportingAPIEndpointV2}/deposit-summary-v2`,
  DASHBOARD_SUMMARY_STATS: `${reportingAPIEndpointV2}/dashboard-summary-stats`,
  TENANCY_SCHEDULE: `${reportingAPIEndpointV2}/tenancy-schedule-v2`,
  AGENCY_GROUP_COMMISSION_SPLIT: `${reportingAPIEndpointV1}/agency_group_commission_split`,
  BILLING: `${reportingAPIEndpointV1}/billing_report`,
  TPN_REPORT: `${reportingAPIEndpointV2}/tpn`,
  AGENCY_SUMMARY_CHART: `${reportingAPIEndpointV2}/agency-summary`,
  AGENT_COMMISSION_REPORT: `${REACT_APP_API_URL}/accounting/agent_commission/report`,
  AGENT_COMMISSION: `${reportingAPIEndpointV2}/agent-commission`,
  DEPOSIT_FEE_STATEMENT: `${REACT_APP_API_URL}/accounting/receipt/report`,
  PROPERTIES: `${reportingAPIEndpointV2}/properties`,
  PROPERTY_TAX_STATEMENT: `${reportingAPIEndpointV2}/property-tax-statement`,
  OWNER_STATEMENT: `${reportingAPIEndpointV2}/owner-statement`,
  FRANCHISE_PERFORMANCE: `${reportingAPIEndpointV2}/franchise-performance`,
  ROYALTY_REPORT: `${reportingAPIEndpointV2}/royalty-report`,
  REPORT_USAGE: `${reportingAPIEndpointV2}/report-usage`,
  ACTIVE_AGENCIES: `${reportingAPIEndpointV2}/active-agencies`,
  ACTIVE_LEASES: `${reportingAPIEndpointV2}/active-leases`,
  AVAILABLE_FUNDS: `${reportingAPIEndpointV2}/available-funds-v2`,
  FICA_COMPLIANCE: `${reportingAPIEndpointV2}/fica-compliance`,
  SUSPENSE_ACCOUNT_ALLOCATED: `${reportingAPIEndpointV2}/suspense-account/allocated`,
  SUSPENSE_ACCOUNT_UNALLOCATED: `${reportingAPIEndpointV2}/suspense-account/unallocated`,
  SUSPENSE_ACCOUNT_CSV: `${reportingAPIEndpointV2}/suspense-account`,
  SUSPENSE_ACCOUNT_STATS: `${reportingAPIEndpointV2}/suspense-account/stats`,
  SUSPENSE_ACCOUNT_LIST: `${reportingAPIEndpointV2}/suspense-account/:list/list`,
  SUSPENSE_ACCOUNT_REFERENCE: `${reportingAPIEndpointV2}/suspense-account/reference/:reference`,
  WALLETS: `${reportingAPIEndpointV2}/wallets`,
  DOWNLOAD_CREDIT_NOTE_PDF: `${reportingAPIEndpointV2}/credit-note/:invoiceId/pdf`,
}

export const rentInvoiceCategories = ['RentInvoice', 'ProRataRent']
export const inspectionInvoiceCategories = ['IncomingInspection', 'OutgoingInspection']
export const depositInvoiceCategories = [
  'DamageDeposit',
  'ServiceDeposit',
  'KeyDeposit',
  'DepositTopUp',
  'DepositHandover',
]
export const utilitiesInvoiceCategories = [
  'Utilities',
  'UtilityElectricity',
  'UtilityHomeUser',
  'UtilityRefuse',
  'UtilityWaste',
  'UtilityWater',
]
export const leaseStatuses = ['Draft', 'Active', 'Expiring', 'Renewals']
export const leaseType = ['Managed', 'Unmanaged']

/** The largest page the list endpoints accept */
export const SUSPENSE_LIST_MAX_PAGE_SIZE = 300

/**
 * What each suspense list opens on: newest first. The allocated history is paged at the API's
 * default size; unallocated is shown whole, so it asks for the largest pages.
 */
export const SUSPENSE_LIST_DEFAULT_QUERIES = {
  unallocated: { page: 1, pageSize: SUSPENSE_LIST_MAX_PAGE_SIZE, sort: 'received', order: 'desc', search: '' },
  allocated: { page: 1, pageSize: 50, sort: 'allocated', order: 'desc', search: '' },
} as const

/** Lists shown whole: every page is fetched and combined. */
export const SUSPENSE_LISTS_UNPAGED: readonly string[] = ['unallocated']

/**
 * How long after an allocation the lists and stats are refetched: the reporting read side lags
 * the allocation, typically by under a second. A run of allocations shares one refetch.
 */
export const SUSPENSE_REFRESH_DELAY_MS = 2000

/** The API rejects longer search terms */
export const SUSPENSE_LIST_SEARCH_MAX_LENGTH = 100
